import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { Chip } from 'components'

import styles from './DashboardCard.module.scss'

interface DashboardCardProps extends PropsWithChildren {
  className?: string
  comingSoon?: boolean
  title: string
}

const DashboardCard = ({ children, className, comingSoon = false, title }: DashboardCardProps) => {
  const { t } = useTranslation('dashboard')

  return (
    <section className={[styles.card, className].filter(Boolean).join(' ')}>
      <h2>{title}</h2>
      <div className={styles.body}>
        <div
          aria-hidden={comingSoon || undefined}
          ref={(element) => {
            element?.toggleAttribute('inert', comingSoon)
          }}
        >
          {children}
        </div>
        {comingSoon && (
          <div className={styles.overlay}>
            <Chip color="neutral">{t('comingSoon')}</Chip>
          </div>
        )}
      </div>
    </section>
  )
}

export default DashboardCard
